// eslint-disable-next-line no-restricted-imports
import { fromJS, Map, Record } from '@gonfalon/immutable-shim/immutableShim';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';

const memberFullName = (m: MemberSummary) => [m.firstName, m.lastName].join(' ').trim();
const memberDisplayName = (m: MemberSummary): string => m.getFullName() || m.email;

export class MemberSummary extends Record({
  _links: Map(),
  _id: '',
  firstName: '',
  lastName: '',
  role: '',
  email: '',
  _avatarUrl: '',
}) {
  getFullName() {
    return memberFullName(this as MemberSummary);
  }

  getDisplayName() {
    return memberDisplayName(this as MemberSummary);
  }
}

export const createMemberSummary = (props?: CreateFunctionInput<MemberSummary>) =>
  props instanceof MemberSummary ? props : new MemberSummary(fromJS(props));
